import {
  SVG,
  Selectors,
  USER_LEVEL_ICONS,
  useIsDesktop,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {RewardsInfoState} from '@eCommerce/frontend-legacy-shared-library-native/lib/typescript/store/auth';
import {Pressable, Text, View} from 'native-base';
import React, {useState} from 'react';

import {MonthObj} from '../MonthDropdown/months';
import CreditsTable from './CreditsTable';

const EMPTY_INFORMATION = 'empty_information';

export enum CreditsTab {
  earned = 'CREDITS EARNED',
  redeemed = 'CREDITS REDEEMED',
}

export interface CreditsDisplayProps {
  selectedMonth: MonthObj | undefined;
}

const CreditsDisplay = (props: CreditsDisplayProps) => {
  const {selectedMonth} = props;
  const isDesktop = useIsDesktop();
  const [selectedTab, setSelectedTab] = useState(CreditsTab.earned);
  const rewardsInfo = useWidgetState(
    Selectors.rewardsInfoSelector
  ) as RewardsInfoState;
  const currentLevel = useWidgetState(
    Selectors.userExtendedTierCodeSelector
  ) as string;

  const isEarned = selectedTab === CreditsTab.earned;

  const totalNumber = isEarned
    ? rewardsInfo?.earnedRewards?.total
    : rewardsInfo?.redeemedRewards?.total;

  const tabs = Object.keys(CreditsTab).map(tab => {
    const isSelected = selectedTab === CreditsTab[tab];
    return (
      <Pressable
        borderBottomWidth={isSelected ? 2 : 0}
        borderColor="tuna"
        onPress={() => setSelectedTab(CreditsTab[tab])}
        key={`credits-tab-${tab}`}>
        <Text
          letterSpacing="0.86px"
          lineHeight="36px"
          fontSize="12px"
          bold={isSelected}>
          {CreditsTab[tab]}
        </Text>
      </Pressable>
    );
  });

  if (!selectedMonth) {
    return null;
  }

  if (!rewardsInfo || rewardsInfo.rewardsInfoStatus === EMPTY_INFORMATION) {
    return (
      <Text>
        No transaction history to display. Start earning rewards today by
        visiting a Caesar&apos;s Rewards resort. Stay, Play and Dine like a
        Caesar and enjoy the all the benefits of the Empire.
      </Text>
    );
  }

  return (
    <View
      px={isDesktop ? '48px' : '16px'}
      py={isDesktop ? '42px' : '16px'}
      bgColor="ghostWhite"
      borderRadius="8px">
      <View
        mb={isDesktop ? '50px' : '36px'}
        flexDirection="row"
        maxW="262px"
        justifyContent="space-between">
        {tabs}
      </View>
      <View alignItems="center" flexDirection="row" mb="24px">
        <SVG source={USER_LEVEL_ICONS[currentLevel]} width={25} height={25} />
        <Text ml="12px">
          <Text bold>{totalNumber}</Text> Rewards Credit{' '}
          {isEarned ? 'Earned' : 'Redeemed'}{' '}
        </Text>
      </View>
      <View>
        <CreditsTable
          rewardsList={
            isEarned
              ? rewardsInfo.earnedRewards?.byMonth[selectedMonth.key]
              : rewardsInfo.redeemedRewards?.byMonth[selectedMonth.key]
          }
          selectedTab={selectedTab}
        />
      </View>
    </View>
  );
};

export default CreditsDisplay;
